import { Container, Typography } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Admin from './components/Admin';
import { SignIn } from './components/Auth';
import Order from './components/Order';
import { Header } from './layouts';

function App() {
  return (
    <Router >
      <Header />
      <Routes>
        <Route path='/' element={<Order />} />
        <Route path='/signin' element={<SignIn />} />
        <Route path='/admin/*' element={<Admin />} />            
      </Routes>
    </Router>
  );
}

export default App;
